import ApiConnector from "@/repository/connector";

class Clients {
  async get(params) {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.get(`/v1/clients/`, {
      params,
    });
    result.value = response.data;
    result.error = response.detail;
    return result;
  }

  async getById(id) {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.get(`/v1/clients/${id}/`);
    result.value = response.data;
    result.error = response.detail;
    return result;
  }
}

export default new Clients();
